export default {
  couponReadList: {
    感謝惠顧: "感谢惠顾",
    X已為你送上Y張優惠券: "{X}以为你送上{Y}张优惠券",
    有效期: "有效期:",
    查看優惠券: "查看优惠券",
    關閉窗口: "关闭窗口",
  },
};
